export const START = 'start';
export const DRAG = 'drag';
export const STOP = 'stop';
export const CLEAR = 'clear';
